import { Component, inject } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, Subject } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);


  resetPasswordForm: FormGroup;

  loading$: Subject<boolean | null> = new Subject();

  constructor() {
    const formBuilder = inject(FormBuilder);
    const activatedRoute = inject(ActivatedRoute);

    this.resetPasswordForm = formBuilder.group({
      token: [activatedRoute.snapshot.params['token'] ?? null, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(8)]],
      confirm_password: [null, [
        Validators.required,
        this.passwordMatchValidator('password')
      ]],
    });
  }

  onSubmit(): void {
    this.loading$.next(true);

    this.authService.resetPassword(this.resetPasswordForm.value).pipe(
      finalize(() => {
        this.loading$.next(false);
      })
    ).subscribe(() => {
      this.router.navigate(['/login']);
    });
  }

  private passwordMatchValidator(relatedControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const relatedValue = control.parent?.get(relatedControlName)?.value;

      if (! value || ! relatedValue) {
        return null;
      }

      return value !== relatedValue ? { notMatch: true } : null;
    }
  }

}
